var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('apexchart',{staticClass:"overflow-hidden",attrs:{"options":_vm.options,"series":_vm.options.series,"type":_vm.options.chart.type,"height":_vm.options.chart.height,"width":_vm.options.chart.width}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }